import { REPORT_SOURCES, reportsOfSource, TReportSource } from '../../reportSources';
import type { IReport } from '@/lib/interface.ts';
import { Button } from '@/components/ui';
import { useUrlParams } from '../../hooks';
import { cn } from '@/lib/utils';

const ControlsFiltersSource = ({ reports }: { reports: IReport[] }) => {

	const { source, changeSource } = useUrlParams();

	return (
		<div className='flex flex-wrap justify-center gap-2 md:justify-start'>
			{
				REPORT_SOURCES.map(
					({ value, title }: { value: TReportSource; title: string }) => {
						const isActive = source === value;
						return (
							<Button
								key={value}
								size={'sm'}
								variant={'outline'}
								onClick={() => changeSource(value)}
								className={cn(
									'rounded-full gap-2',
									isActive && 'bg-purple-600 border-purple-600 text-white hover:bg-purple-600 hover:text-white'
								)}>
								{title}
								<span className={cn(
									'rounded-full px-2 text-xs font-semibold',
									isActive ? 'bg-white/20' : 'bg-muted'
								)}>
									{reportsOfSource(reports, value).length}
								</span>
							</Button>
						);
					}
				)
			}
		</div>
	);

};

export default ControlsFiltersSource;
